const RECURRING_BATCH_REFERENCE = /^LTR\d+$/i

export const isRecurringBatchReference = (text: string): boolean =>
    RECURRING_BATCH_REFERENCE.test(text.trim())

export const normaliseRecurringBatchReference = (text: string): string =>
    text.trim().toUpperCase()

export const recurringBatchSearchPath = (reference: string): string =>
    `/search/${encodeURIComponent(normaliseRecurringBatchReference(reference))}`

type RouteValue = string | null | (string | null)[] | undefined

const joinRouteValue = (value: RouteValue): string =>
    (Array.isArray(value)
        ? value.filter(Boolean).join('/')
        : (value ?? '')
    ).trim()

export const searchTermFromRoute = (
    pathParam: RouteValue,
    queryParam: RouteValue,
): string => joinRouteValue(pathParam) || joinRouteValue(queryParam)
